<template>
  <div>
    <div class="view-container" v-if="importError && importError.message">
      <FileImportError :error="importError" @close="closeImportError"/>
    </div>
    <div class="view-container">
      <vue-portal to="hrsys-navbar-actions">
        <div class="flex">
          <base-header-title :title="$t('modules.users')"/>
          <vx-tooltip :text="$t('buttons.create')" class="ml-2" position="bottom">
            <base-button @click="$router.push({ name: 'userDetails', params: { id: 0 } })" class="self-end"
                         icon="plus"/>
          </vx-tooltip>
          <vx-tooltip :text="$t('buttons.import')" position="bottom">
            <FileImport :options="flowConfig" @fileError="fileError" @fileSuccess="fileSuccess">
              <BaseIcon fixed-width name="upload"/>
            </FileImport>
          </vx-tooltip>
          <vx-tooltip :text="$t('buttons.downloadExample')" class="ml-2" position="bottom">
            <base-button :loading="downloadingExample" @click="downloadExcelExample" class="self-end" icon="download"/>
          </vx-tooltip>
        </div>
      </vue-portal>

      <base-loader :loading="loadingContent">
        <base-search @search="search" v-model="queryParams.search"/>
        <users-table :header="tableHeader"
                     :users="list"
                     @changeStatus="changeStatus"
                     @edit="editUser"
                     id="usersTable"/>
        <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
      </base-loader>
    </div>
  </div>
</template>

<script>
  import FileImport from '../../components/_file-import';
  import FileImportError from '../../components/_file-import-error';
  import UsersTable from '../../components/users/UsersTable'
  import Pagination from '../../components/Pagination'
  import Users from '../../services/Users'
  import BaseButton from "../../components/_base-button";

  export default {
    name: 'Users',
    components: {
      BaseButton,
      FileImport,
      FileImportError,
      UsersTable,
      Pagination
    },
    data: () => ({
      list: [],
      pagination: {},
      importError: {
        message: '',
        errors: []
      },
      flowConfig: {
        singleFile: true,
        testChunks: false,
        allowDuplicateUploads: true,
        attributes: {accept: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'},
        target: `${process.env.VUE_APP_API_URL}v1/users/actions/import`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
      },
      queryParams: {
        page: 1,
      },
      loadingContent: false,
      downloadingExample: false
    }),
    methods: {
      editUser (user) {
        // let fullName = `${user.name} ${user.surname}`
        // this.$router.push({name: 'userDetails', params: {id: user.id}, query: {fullName}})
        this.$router.push({name: 'userDetails', params: {id: user.id}})
      },
      changePage (newPage) {
        this.queryParams.page = newPage
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.getUsers()
      },
      getUsers () {
        // this.$vs.loading({container: "#usersTable"})
        this.loadingContent = true
        Users.list(this.queryParams).then(response => {
          this.list = response.data
          this.pagination = response.meta.pagination
        }).finally(() => {
          // this.$vs.loading.close('#usersTable>.con-vs-loading')
          this.loadingContent = false
        })
      },
      search () {
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.queryParams.page = 1
        this.getUsers()
      },
      getUrlParams () {
        let vm = this;
        if (this.$route.query.page) {
          vm.queryParams = Object.assign({}, vm.$route.query);
        }
      },
      fileSuccess () {
        this.importError = {}
        this.$notificationService.success(this.$t('users.import.success'))
        this.search()
      },
      fileError (error) {
        this.importError = JSON.parse(error.message)
      },
      closeImportError () {
        this.importError = {}
      },
      downloadExcelExample () {
        this.downloadingExample = true
        Users.downloadExcelExample().then(() => {
        }).catch(error => {
          this.$notificationService.error(error)
        }).finally(() => this.downloadingExample = false)
      },
      changeStatus (user) {
        let updatedUserIndex = this.list.findIndex((obj => obj.id === user.id));
        if (user.is_enabled) {
          Users.disable(user.id).then(res => {
            this.list[updatedUserIndex].is_enabled = res.data.is_enabled
            this.$notificationService.success('User disabled!')
          }).catch(error => {
            this.$notificationService.error(error)
          })
        } else {
          Users.enable(user.id).then(res => {
            this.list[updatedUserIndex].is_enabled = res.data.is_enabled
            this.$notificationService.success('User enabled!')
          }).catch(error => {
            this.$notificationService.error(error)
          })
        }
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('users.table.name'),
          this.$t('users.table.surname'),
          this.$t('users.table.email'),
          this.$t('users.table.phone'),
          this.$t('users.table.role'),
          this.$t('users.table.status'),
          this.$t('users.table.actions')
        ])
      },
    },
    mounted () {
      this.getUrlParams()
      this.getUsers()
    },
  }
</script>

<style scoped>

</style>
